@if (isLegacyLayout()) {
  <div
    [ngClass]="{
      main__container: horizontalAutoMargin && pageStyle === defaultPage,
      'main__container--narrow': horizontalAutoMargin && pageStyle === narrowPage,
    }"
  >
    <div [class]="horizontalOuterMargin ? pageContainerClass : ''">
      <div class="row page__content">
        <div class="col-12" [ngClass]="noMargin ? 'no-margin' : ''">
          <ng-container *ngTemplateOutlet="childContent"></ng-container>
        </div>
      </div>
    </div>
  </div>
} @else {
  <ftr-panel
    [panelStyle]="!horizontalAutoMargin || noMargin ? 'flat' : pageStyle === 'default' ? 'centered' : pageStyle"
    [displayMode]="'FILL'"
  >
    <ng-container *ngTemplateOutlet="childContent"></ng-container
  ></ftr-panel>
}

<ng-template #childContent><ng-content></ng-content></ng-template>
